import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class ToasterService {

  private status = new BehaviorSubject<ToastModel>(null);
  status$ = this.status.asObservable();

  constructor() { }

  show(input: ToastModel) {
    this.status.next(input)
  }

  closeToaster() {
    this.status.next(null);
  }
}

export interface ToastModel {
  message: string;
  type: ToasterType
}

export enum ToasterType {
  success,
  warning,
  error
}
